import React from 'react';

import { IconSize } from 'widget/shared/icons/BaseIcon';
import IconButton from 'widget/shared/ui/IconButton';
import { WidgetTexts } from 'widget/consts/texts';
import DownloadIcon from 'widget/shared/icons/DownloadIcon';
import CrossIcon from 'widget/shared/icons/CrossIcon';

import styles from './MediaViewerToolbar.module.scss';

type MediaViewerToolbarProps = {
  onDownloadMedia?: () => void;
  onCloseMediaViewer?: () => void;
  controlsStyle?: React.CSSProperties;
};

const MediaViewerToolbar: React.FC<MediaViewerToolbarProps> = ({
  onDownloadMedia,
  onCloseMediaViewer,
  controlsStyle
}) => {
  return (
    <div className={styles['media-viewer-toolbar']} style={controlsStyle}>
      <IconButton
        className={styles['media-viewer-toolbar__button']}
        onClick={onDownloadMedia}
        aria-label={WidgetTexts.mediaViewer.download.label}
      >
        <DownloadIcon size={IconSize.M} />
      </IconButton>
      <IconButton
        className={styles['media-viewer-toolbar__button']}
        onClick={onCloseMediaViewer}
        aria-label={WidgetTexts.mediaViewer.close.label}
      >
        <CrossIcon size={IconSize.M} />
      </IconButton>
    </div>
  );
};

export default React.memo(MediaViewerToolbar);
